import Axios from "axios";
import config from "../config";


class TotemService {
  constructor() {
    this.api = Axios.create({
      baseURL: config.URL_ENDPOINT,
    });
  }

  async validateTotemId(payload) {
    try {
      const response = await this.api.post(`/totem-app/auth`, payload);
      console.log(response)
      const data = response.data;

      return data;
    } catch (error) {
      console.error("Erro ao buscar instituições", error);
      throw error;
    }
  }

  async facialRecognition(payload) {
    try {
      const response = await this.api.post(`usuario-instituicoes/reconhecimento-facial`, payload);
      const data = response.data;

      return data;
    }catch(error) {
      console.error("Erro ao realizar reconhecimento facial", error);
      throw error;
    }
  }
}

export default TotemService;